import {PagedCuratedVehiclesAndLookupItems} from "../../Models/PagedCuratedVehiclesAndLookupItems";
import {
  ApplicationDownPaymentResponse,
  VehicleFilterWithPaging,
  VehicleWebViewFiltersWithPaging,
  WebViewVehicle
} from "@amsanalytics/react-shared-library";
import {CuratedSiteApplicationConfig} from "../../Models/CuratedSiteApplicationConfig";

export const LOAD_CURATED_VEHICLES = 'LOAD_CURATED_VEHICLES';
export const LOAD_CURATED_VEHICLES_SUCCESS = 'LOAD_CURATED_VEHICLES_SUCCESS';

export interface LoadCuratedVehiclesAction {
  type: typeof LOAD_CURATED_VEHICLES;
  payload: { clientId: string, filters: VehicleFilterWithPaging }
}
export const loadCuratedVehicles = (clientId: string, filters: VehicleFilterWithPaging): LoadCuratedVehiclesAction => {
  return {
    type: LOAD_CURATED_VEHICLES,
    payload: { clientId, filters }
  }
}

export interface LoadCuratedVehiclesSuccessAction {
  type: typeof LOAD_CURATED_VEHICLES_SUCCESS;
  payload: PagedCuratedVehiclesAndLookupItems
}
export const loadCuratedVehiclesSuccess = (vehiclesAndLookups: PagedCuratedVehiclesAndLookupItems): LoadCuratedVehiclesSuccessAction => {
  return {
    type: LOAD_CURATED_VEHICLES_SUCCESS,
    payload: vehiclesAndLookups
  }
}

export const LOAD_CURATED_VEHICLE_DETAILS = 'LOAD_CURATED_VEHICLE_DETAILS';
export const LOAD_CURATED_VEHICLE_DETAILS_SUCCESS = 'LOAD_CURATED_VEHICLE_DETAILS_SUCCESS';

export interface LoadCuratedVehicleDetailsAction {
  type: typeof LOAD_CURATED_VEHICLE_DETAILS;
  payload: { clientId: string, vehicleId: string | null, stockNumber: string | null }
}
export const loadCuratedVehicleDetail = (clientId: string, vehicleId: string | null, stockNumber: string | null): LoadCuratedVehicleDetailsAction => {
  return {
    type: LOAD_CURATED_VEHICLE_DETAILS,
    payload: { clientId, vehicleId, stockNumber }
  }
}

export interface LoadCuratedVehicleDetailsSuccessAction {
  type: typeof LOAD_CURATED_VEHICLE_DETAILS_SUCCESS;
  payload: WebViewVehicle
}
export const loadCuratedVehicleDetailsSuccess = (vehicle: WebViewVehicle): LoadCuratedVehicleDetailsSuccessAction => {
  return {
    type: LOAD_CURATED_VEHICLE_DETAILS_SUCCESS,
    payload: vehicle
  }
}

export const CLEAR_CURATED_VEHICLE_DETAILS_SUCCESS = 'CLEAR_CURATED_VEHICLE_DETAILS_SUCCESS';

export interface ClearCuratedVehicleDetailsSuccessAction {
  type: typeof CLEAR_CURATED_VEHICLE_DETAILS_SUCCESS;
}
export const clearCuratedVehicleDetailsSuccess = (): ClearCuratedVehicleDetailsSuccessAction => {
  return {
    type: CLEAR_CURATED_VEHICLE_DETAILS_SUCCESS
  }
}

export const SET_VEHICLE_FILTERS_SUCCESS = 'SET_VEHICLE_FILTERS_SUCCESS';

export interface SetVehicleFiltersSuccessAction {
  type: typeof SET_VEHICLE_FILTERS_SUCCESS;
  payload: VehicleWebViewFiltersWithPaging | null
}
export const setVehicleFilters = (filters: VehicleWebViewFiltersWithPaging | null): SetVehicleFiltersSuccessAction => {
  return {
    type: SET_VEHICLE_FILTERS_SUCCESS,
    payload: filters
  }
}

export const LOAD_CURATED_APPLICATION_DETAILS = 'LOAD_CURATED_APPLICATION_DETAILS';
export const LOAD_CURATED_APPLICATION_DETAILS_SUCCESS = 'LOAD_CURATED_APPLICATION_DETAILS_SUCCESS';

export interface LoadCuratedApplicationDetailsAction {
  type: typeof LOAD_CURATED_APPLICATION_DETAILS;
  payload: { clientId: string, customerPortalLinkId: string}
}
export const loadCuratedApplicationDetails = (clientId: string, customerPortalLinkId: string): LoadCuratedApplicationDetailsAction => {
  return {
    type: LOAD_CURATED_APPLICATION_DETAILS,
    payload: { clientId, customerPortalLinkId }
  }
}

export interface LoadCuratedApplicationDetailsSuccessAction {
  type: typeof LOAD_CURATED_APPLICATION_DETAILS_SUCCESS;
  payload: CuratedSiteApplicationConfig
}
export const loadCuratedApplicationDetailsSuccess = (curatedSiteApplicationConfig: CuratedSiteApplicationConfig): LoadCuratedApplicationDetailsSuccessAction => {
  return {
    type: LOAD_CURATED_APPLICATION_DETAILS_SUCCESS,
    payload: curatedSiteApplicationConfig
  }
}

export const GET_DOWN_PAYMENT_HISTORIES = 'GET_DOWN_PAYMENT_HISTORIES';
export const GET_DOWN_PAYMENT_HISTORIES_SUCCESS = 'GET_DOWN_PAYMENT_HISTORIES_SUCCESS';

export interface GetDownPaymentHistoriesAction {
  type: typeof GET_DOWN_PAYMENT_HISTORIES;
  payload: { applicationId: string, clientId: string };
}
export const getDownPaymentHistories = (applicationId: string, clientId: string): GetDownPaymentHistoriesAction => {
  return {
    type: GET_DOWN_PAYMENT_HISTORIES,
    payload: { applicationId, clientId }
  };
};

export interface GetDownPaymentHistoriesSuccessAction {
  type: typeof GET_DOWN_PAYMENT_HISTORIES_SUCCESS;
  payload: ApplicationDownPaymentResponse[];
}
export const getDownPaymentHistoriesSuccess = (applicationDownPaymentResponses: ApplicationDownPaymentResponse[]): GetDownPaymentHistoriesSuccessAction => {
  return {
    type: GET_DOWN_PAYMENT_HISTORIES_SUCCESS,
    payload: applicationDownPaymentResponses
  };
};


export type CuratedVehiclesAction =
  | LoadCuratedVehiclesAction
  | LoadCuratedVehiclesSuccessAction
  | LoadCuratedVehicleDetailsAction
  | LoadCuratedVehicleDetailsSuccessAction
  | ClearCuratedVehicleDetailsSuccessAction
  | SetVehicleFiltersSuccessAction
  | LoadCuratedApplicationDetailsAction
  | LoadCuratedApplicationDetailsSuccessAction
  | GetDownPaymentHistoriesAction
  | GetDownPaymentHistoriesSuccessAction
  ;
